import(/* webpackMode: "eager" */ "/github/workspace/nextjs-frontend/src/app/pdf-encrypter-decrypter/page.tsx");
